import { useMemo } from "react";

interface Article {
  nb: number;
}
type Commande = Record<string, Article> | null | undefined;

export const useTotalArticles = (commande: Commande): number => {
  const totalArticles = useMemo(() => {
    return Object.values(commande || {}).reduce(
      (sum, item) => sum + item.nb,
      0
    );
  }, [commande]);

  return totalArticles;
};
